import React from 'react';

import styled from 'styled-components';

import { RecommendationDetailsType } from 'types/recommendations';

import RecommendationCompanyReasoning from './RecommendationCompanyReasoning';

const ReasoningContainer = styled.div`
  display: flex;
  gap: 20px;
  flex-direction: column;
  margin: 10px 30px;
`;

const Title = styled.div`
  font-size: 22px;
  font-family: var(--font-bold);
  color: var(--text-primary);
  padding-left: 30px;
  padding-top: 10px;
`;

type Props = {
  recommendation: RecommendationDetailsType;
};

const RecommendationCompany = ({ recommendation }: Props) => {
  return (
    <>
      <Title>Overall</Title>
      <ReasoningContainer>
        <RecommendationCompanyReasoning description={recommendation.problem} />
        <RecommendationCompanyReasoning description={recommendation.solution} />
      </ReasoningContainer>
    </>
  );
};

export default RecommendationCompany;
